import React from 'react'
import moment from 'moment'
import { color } from 'ui/variables'
import ShowHide from 'ui/ShowHide'
import { Body1, Display4 } from 'ui/typography'
import Loader from 'ui/Loader'
import Block from 'ui/Block'
import Alert from 'ui/Alert'
import Link from 'ui/Link'
import ActivityIcon from './ActivityIcon'
import ActivityLocation from './ActivityLocation'
import css from './ActivityTable.module.css'

const ActivityTable = props => {
  return (
    <div className={props.isLoading ? css.loading : ''}>
      <div className={css.heading}>
        <Display4>{props.heading}</Display4>
      </div>
      <div className={css.body}>
        <ShowHide show={props.isLoading}>
          <Loader isLoading={props.isLoading} padding='200' />
        </ShowHide>
        <ShowHide show={props.items.length !== 0 && !props.isLoading}>
          <table className={css.table}>
            <thead>
              <tr>
                <th><Body1>&nbsp;</Body1></th>
                <th><Body1>Activity</Body1></th>
                <th><Body1>Location</Body1></th>
                <th><Body1>User</Body1></th>
                <th><Body1>Date</Body1></th>
              </tr>
            </thead>
            <tbody>
              {props.items.map((item, index) => (
                <tr key={`activity_item_${item.type}_${index}`} className={itemClasses(item)}>
                  <td>
                    <Body1>
                      <ActivityIcon type={item.type} event={item.event} />
                    </Body1>
                  </td>
                  <td>
                    <Body1>
                      {item.event}
                    </Body1>
                  </td>
                  <td>
                    <Body1>
                      <ActivityLocation event={item.event} type={item.type} properties={item.properties} />
                    </Body1>
                  </td>
                  <td>
                    <Body1>
                      {item.properties.initiatorEmail}
                    </Body1>
                  </td>
                  <td>
                    <Body1>
                      {moment(item.createdAt).format('MM/DD/YY hh:mm A')}
                    </Body1>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </ShowHide>
        <ShowHide show={!props.isLoading && props.didRequestFail}>
          <Block space={28}>
            <Alert type='danger' title='There was an error loading your activity.'>
              If the problem persists, please <Link rel='external' target='_blank' href='/help/contact' >contact our customer support team.</Link>
            </Alert>
          </Block>
        </ShowHide>
        <ShowHide show={props.didReceiveActivity && !props.hasActivity && !props.didRequestFail}>
          <div className={css.empty}>
            <Body1 color={color.grey[300]}>There hasn’t been any activity in the last 30 days.</Body1>
          </div>
        </ShowHide>
        <ShowHide show={props.hasActivity && props.items.length === 0 && !props.isLoading}>
          <div className={css.empty}>
            <Body1 color={color.grey[300]}>No activity matches that filter</Body1>
          </div>
        </ShowHide>
      </div>
    </div>
  )
}

function itemClasses ({ event }) {
  if ((/deleted/i).test(event) || (/failed/i).test(event)) {
    return css.danger
  }

  return ''
}

export default ActivityTable



// WEBPACK FOOTER //
// ./components/ActivityTable.js